export default __webpack_public_path__ + "static/media/disarmingaggression.565e01bf.png";